<template>
  <div v-if="currentEchange">
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Échanges'"
          :description="'Aperçu d\'une échange'"
        />
      </div>

      <div class="col-lg-6 mt-lg-4">
        <div class="row" v-if="tiers">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Client concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Nom :</span
                    ><span>
                      <a
                        style="cursor: pointer"
                        @click.prevent="goTiersShow"
                        class="mr-4"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        <u class="text-custom-primary"> {{ tiers.nom }}</u>
                      </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">Échange</td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Titre :</span
                    ><span class="mr-4">
                      {{ currentEchange.titre }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4 mt-2"
          @click.prevent="goListEchange"
        >
          Liste des échanges
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4 mt-2"
          @click.prevent="
            $router
              .push({
                name: routes.create,
                params: { prov: tiers.id },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel échange
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mt-2"
          @click.prevent="
            $router
              .push({
                name: routes.edit,
                params: { id: currentEchange.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: routes.show,
                params: { id: currentEchange.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Échange</b-nav-item
            >
            <b-nav-item
              :to="{
                name: routes.showDocument,
                params: {
                  documentUuid: currentEchange.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import names from '@/constants/routes/echange/echange';

export default {
  data() {
    return {
      title: 'Gestion des échanges - Aperçu',
      routes: names,
    };
  },
  computed: {
    ...mapGetters('echange', ['currentEchange', 'tiers']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('echange', ['getEchange']),
    init() {
      this.getEchange({ id: this.$route.params.id });
    },
    goListEchange() {
      return this.$router
        .push({
          name: 'client-show-echange',
          params: { id: this.tiers.id },
        })
        .catch(() => {});
    },
    goTiersShow() {
      return this.$router
        .push({
          name: 'client-show',
          params: { id: this.tiers.id },
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>
